export default "__VITE_ASSET__d352b181__"